import { AppDispatch } from "@app/store";

/**
 * Seeds individual getById caches from browse/search result rows so detail pages
 * can render instantly after list navigation without a redundant fetch.
 */
export function seedDetailCacheFromBrowse<T extends { id: number }>(
  api: unknown,
  getByIdEndpoint: string,
  rows: T[],
  dispatch: AppDispatch,
) {
  const upsertQueryData = (api as {
    util: {
      upsertQueryData: (endpoint: string, id: string | number, value: T) => unknown;
    };
  }).util.upsertQueryData;

  for (const row of rows) {
    dispatch(upsertQueryData(getByIdEndpoint, row.id, row) as Parameters<AppDispatch>[0]);
  }
}
